<span *ngIf="cellValue >= 0" class="neutral-dollar">
  {{ (cellValue | currency: 'USD' : 'symbol' : '1.0-0') || '-' }}
</span>
<span *ngIf="cellValue < 0" class="negative-dollar">
  <span>(</span>{{ cellValue < 0 ? (cellValue | currency: 'USD' : 'symbol' : '1.0-0') + ')' : '-' }}
</span>
